import gql from "graphql-tag"

export const tournamentScoreFragment = gql`
  fragment TournamentScore on Score {
    totalWinnerScore
    totalLoserScore
    notes
  }
`

export const tournamentCompetitorFragment = gql`
  fragment TournamentCompetitor on Competitor {
    id
    name
    isActive
    rank
    isReadyToCompete
    amountPaid
    points
    isEliminated
    resultSequence
    isBye
  }
`

export const tournamentMatchFragment = gql`
  fragment TournamentMatch on Match {
    id
    name
    description
    comments
    isActive
    startTime
    endTime
    status
    flightId
    roundId
    winnerDestinationMatchId
    loserDestinationMatchId
    score {
      ...TournamentScore
    }
    venue {
      id
      name
    }
    firstCompetitor {
      id
      name
      rank
    }
    secondCompetitor {
      id
      name
      rank
    }
    winner {
      id
      name
      rank
    }
    loser {
      id
      name
      rank
    }
  }
  ${tournamentScoreFragment}
`
export const tournamentLocationFragment = gql`
  fragment TournamentLocation on Location {
    id
    name
    venues {
      ...TournamentVenue
    }
  }
`

export const tournamentVenueFragment = gql`
  fragment TournamentVenue on Venue {
    id
    name
    isActive
    reservedBy
  }
`

export const tournamentFlightFragment = gql`
  fragment TournamentFlight on Flight {
    id
    name
    description
    comments
    rounds {
      id
      name
      description
      comments
    }
    standings {
      id
      name
      resultSequence
      points
    }
  }
`

export const tournamentMainFragment = gql`
  fragment TournamentMain on Tournament {
    id
    userId
    name
    description
    comments
    regulations
    isActive
    isPublic
    sport
    circuit
    startDate
    endDate
    format
  }
`

export const tournamentMatchStartedFragment = gql`
  fragment TournamentMatchStarted on Tournament {
    id
    venuesToUse {
      ...TournamentVenue
    }
    matches {
      ...TournamentMatch
    }
  }
  ${tournamentVenueFragment}
  ${tournamentMatchFragment}
`

export const tournamentMatchEndedFragment = gql`
  fragment TournamentMatchEnded on Tournament {
    ...TournamentMatchStarted
    competitors {
      ...TournamentCompetitor
    }
    flights {
      ...TournamentFlight
    }
  }
  ${tournamentMatchStartedFragment}
  ${tournamentCompetitorFragment}
  ${tournamentFlightFragment}
`

export const tournamentQuery = gql`
  query tournament($id: ID!) {
    tournament(id: $id) {
      ...TournamentMain
      location {
        ...TournamentLocation
      }
      venuesToUse {
        ...TournamentVenue
      }
      competitors {
        ...TournamentCompetitor
      }
      flights {
        ...TournamentFlight
      }
      matches {
        ...TournamentMatch
      }
    }
  }
  ${tournamentMainFragment}
  ${tournamentCompetitorFragment}
  ${tournamentMatchFragment}
  ${tournamentLocationFragment}
  ${tournamentVenueFragment}
  ${tournamentFlightFragment}
`



// WEBPACK FOOTER //
// ./src/graphql/tournament.js